import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/Login/LoginPage';
import { NotFoundPage } from './pages/Error/NotFoundPage';
import { SidebarLayout } from './layouts/SidebarLayout';
import { ClientListPage } from './pages/Clients/ClientListPage';
import { EmployeeLayout } from './layouts/Person/Employee/EmployeeLayout';
import { EmployeeListPage } from './pages/Employees/EmployeeListPage';
import { ClientPersonalSection } from './pages/Clients/Client/Personal/ClientPersonalSection';
import { ClientDetailsSection } from './pages/Clients/Client/Details/ClientDetailsSection';
import { ClientIppSection } from './pages/Clients/Client/IPP/ClientIppSection';
import { ApplicantFormPage } from './pages/Applicants/Form/ApplicantFormPage';
import { ApplicantsListPage } from './pages/Applicants/List/ApplicantsListPage';
import { EmployeeAvailabilitySection } from './pages/Employees/Employee/Availability/EmployeeAvailabilitySection';
import { EmployeePersonalSection } from './pages/Employees/Employee/Personal/EmployeePersonalSection';
import { EmployeeDocumentsSection } from './pages/Employees/Employee/Documents/EmployeeDocumentsSection';
import { ClientLayout } from './layouts/Person/Client/ClientLayout';
import EmployeeEducationSection from './pages/Employees/Employee/Education/EmployeeEducationSection';
import { EmployeeTimeTableSection } from './pages/Employees/Employee/TimeTable/EmployeeTimeTableSection';
import { EmployeeClientPreferencesSection } from './pages/Employees/Employee/Preferences/EmployeeClientPreferencesSection';
import { NewApplicantEmptyFormPage } from './pages/Applicants/Form/NewApplicantEmptyFormPage';
import { NewApplicantClientFormPage } from './pages/Applicants/Form/NewApplicantClientFormPage';
import ProtectedRoutes from './ProtectedRoute';
import AuthProvider from './AuthProvider';
import { NewEmployeePage } from './pages/Employees/Employee/NewEmployee/NewEmployeePage';
import { PlanningLayout } from './layouts/Planning/PlanningLayout';
import { PlanningListPage } from './pages/Planning/PlanningListPage';
import { AuditPage } from './pages/Planning/Audit/AuditPage';
import { ForPlanningPage } from './pages/Planning/ForPlanning/ForPlanningPage';
import { PlanningPage } from './pages/Planning/Planning/PlanningPage';
import { PlannedPage } from './pages/Planning/Planned/PlannedPage';
import { PlanAdjustmentPage } from './pages/Planning/PlanAdjustment/PlanAdjustmentPage';
import { PlansPage } from './pages/Planning/Plans/PlansPage';
import { AccountPage } from './pages/Account/AccountPage';
import { ServicePage } from './pages/Services/ServiceListPage';
import { ServiceLayout } from './layouts/Person/Service/ServiceLayout';
import { ForgotPasswordPage } from './pages/ForgotPassword/ForgotPasswordPage';
import { PasswordResetPage } from './pages/PasswordReset/PasswordResetPage';
import { UserListPage } from './pages/Users/UserListPage';
import { UserDetailsPage } from './pages/Users/Details/UserDetailsPage';
import { UserLayout } from './layouts/Person/User/UserLayout';
import { DetailsPage } from './pages/Services/Service/DetailsPage';
import { LocationsPage } from './pages/Locations/LocationsPage';
import { TagsPage } from './pages/Tag/TagsPage';
import { AttachmentPage } from './pages/Services/Service/AttachmentPage';
import { PriceHistoryPage } from './pages/Services/Service/PriceHistoryPage';
import { HomePage } from './pages/Home/HomePage';
import { subPath } from './subpath.config'
import {ForbiddenPage} from "@/pages/Error/ForbiddenPage";
import { ClientEmployeePreferencesSection } from './pages/Clients/Client/Preferences/ClientEmployeePreferencesSection';
import { ClientFormPage } from './pages/Clients/Form/ClientFormPage';
import { StatisticsPage } from './pages/Statistics/StatisticsPage';


export const Router = (): JSX.Element => {
  return (
    <BrowserRouter basename={subPath}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="login" element={<LoginPage />} />
          <Route
            path="login/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route path="password-reset" element={<PasswordResetPage />} />
          <Route element={<ProtectedRoutes />}>
            <Route element={<SidebarLayout />}>
              <Route path="my-account" element={<AccountPage />} />
              <Route path="clients">
                <Route path="" element={<ClientListPage />} />
                <Route path="new-client" element={<ClientFormPage/>} />
                <Route path=":clientId" element={<ClientLayout />}>
                  {/* <Route index element={<ClientPersonalSection />} /> */}
                  <Route path="personal" element={<ClientPersonalSection />} />
                  <Route path="details" element={<ClientDetailsSection />} />
                  <Route path="ipp" element={<ClientIppSection />} />
                  <Route
                    path="preferences"
                    element={<ClientEmployeePreferencesSection />}
                  />
                </Route>
              </Route>
              <Route path="employees">
                <Route path="" element={<EmployeeListPage />} />
                <Route path="new-employee" element={<NewEmployeePage />} />
                <Route path=":employeeId" element={<EmployeeLayout />}>
                  <Route
                    path="personal"
                    element={<EmployeePersonalSection />}
                  />
                  <Route
                    path="documents"
                    element={<EmployeeDocumentsSection />}
                  />
                  <Route
                    path="education"
                    element={<EmployeeEducationSection />}
                  />
                  <Route
                    path="availability"
                    element={<EmployeeAvailabilitySection />}
                  />
                  <Route
                    path="timetable"
                    element={<EmployeeTimeTableSection />}
                  />
                  <Route
                    path="preferences"
                    element={<EmployeeClientPreferencesSection />}
                  />
                </Route>
              </Route>
              <Route path="users">
                <Route path="" element={<UserListPage />} />
                <Route path=":userId" element={<UserLayout />}>
                  <Route path="info" element={<UserDetailsPage />} />
                </Route>
              </Route>
              <Route path="planning" element={<PlanningLayout />}>
                <Route path="overview" element={<PlanningListPage />} />
                <Route path="for-planning" element={<ForPlanningPage />} />
                <Route path="planning" element={<PlanningPage />} />
                <Route path="planned" element={<PlannedPage />} />
                <Route
                  path="plan-adjustment"
                  element={<PlanAdjustmentPage />}
                />
                <Route path="plans" element={<PlansPage />} />
                <Route path="audit" element={<AuditPage />} />
              </Route>
              <Route path="applicants">
                <Route path="" element={<ApplicantsListPage />} />
                <Route path=":applicantId" element={<ApplicantFormPage />} />
                <Route
                  path="new-empty-form"
                  element={<NewApplicantEmptyFormPage />}
                />
                <Route path="new-client-form">
                  <Route
                    path=":clientId"
                    element={<NewApplicantClientFormPage />}
                  />
                </Route>
              </Route>
              <Route path="*" element={<NotFoundPage />} />
              <Route path="my-account" element={<AccountPage />} />
              <Route path="services">
                <Route path="" element={<ServicePage />} />
                <Route path=":serviceId" element={<ServiceLayout />}>
                  <Route path="details" element={<DetailsPage />} />
                  <Route path="attachments" element={<AttachmentPage />} />
                  <Route path="priceHistory" element={<PriceHistoryPage />}
                  />
                </Route>
              </Route>
              <Route path="locations" element={<LocationsPage />} />
              <Route path="tags" element={<TagsPage />} />
              <Route path="/error/403" element={<ForbiddenPage />} />
              <Route path="statistics">
                <Route path="" element={<StatisticsPage/>}/>
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};
